import { GetterTree } from 'vuex';
import { State } from './configure.store';

const getters: GetterTree<State, State> = {
  getShowAddConfigureAlert: state => {
    return state.showAddConfigureAlert;
  },
  getShowEditConfigureAlert: state => {
    return state.showEditConfigureAlert;
  },
  getShowTotalNotificationChannelsTagged: state => {
    return state.showTotalNotificationChannelsTagged;
  },
  getTotalNotificationChannelIdsTagged: state => {
    return state.totalNotificationChannelIdsTagged;
  },
  getCurrentEditConfigureAlert: state => {
    return state.currentEditConfigureAlert;
  },
  getRules: state => {
    return state.rules;
  },
  getTotalRules: state => {
    return state.totalRules;
  },
  getSearchTotalRules: state => {
    return state.searchTotalRules;
  },
  getNotificationChannels: state => {
    return state.notificationsChannels;
  },
  getMetricsMap: state => {
    return state.metricsMap;
  },
  getMeasurementUnits: state => {
    return state.measurementUnits;
  },
  getAggregationMap: state => {
    return state.agregationMap;
  },
  getCurrentAlertCapability: state => {
    return state.currentCapability;
  },
  getCurrentSubType: state => {
    return state.currentSubType;
  },
  getAlertCapabilities: state => {
    return state.alertCapabilities;
  },
  getAlertApplications: state => {
    return state.alertApplication;
  },
  getCurrentAlertApplication: state => {
    return state.currentApplication;
  },
  getCreateAlertPopupActive: state => {
    return state.isCreateAlertPopupActive;
  },
  getIsSearchedAlarmQuery: state => {
    return state.isSearchedAlarmQuery;
  },
  getIsErrorCodeEnabled: state => {
    return state.isErrorCodeEnabled;
  },
  getEndpoints: state => {
    return state.endpoints;
  },
  getInstances: state => {
    return state.instances;
  }
};
export default getters;